import React from 'react';

// This is a placeholder - the default order receipt uses HTML templates
// rendered directly in MultiStepForm
const OrderReceiptDefault = () => {
  return null;
};

export default OrderReceiptDefault;
